module.exports = __webpack_public_path__ + "img/ground-ground.f4602d67.png";